$(function() {
  $("#password_registration,#user_secret_word").passField({
    validationCallback: function(element, result) {
      if (result.messages.length > 0) {
        element.setCustomValidity(result.messages.join(', '))
        return { strength: 0, messages: result.messages };
      } else {
        element.setCustomValidity("") }
      },
    acceptRate: 1,
    pattern: "aAbcde$2",
    allowEmpty: false,
    showTip: false,
    showGenerate: false,
    showWarn: true,
    errorWrapClassName: 'password-error',
    locale: $('body').data('locale'),
    maskBtn: {
      textMasked: '<i class="fa fa-eye"/>'
    }
  });
});
